export default __webpack_public_path__ + "static/media/arrow-right-black.a69046cf.svg";